import type { SVGProps } from "react";
export interface AlphabetSSquareIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function AlphabetSSquareIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: AlphabetSSquareIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M19.875 6c0-1.036-.84-1.875-1.875-1.875H6c-1.036 0-1.875.84-1.875 1.875v12c0 1.035.84 1.875 1.875 1.875h12c1.035 0 1.875-.84 1.875-1.875zm2.25 12A4.125 4.125 0 0 1 18 22.125H6A4.125 4.125 0 0 1 1.875 18V6A4.125 4.125 0 0 1 6 1.875h12A4.125 4.125 0 0 1 22.125 6z"
      />
      <path
        fill={color}
        d="M9.396 13.433a1.125 1.125 0 0 1 1.38.605l.042.107.051.125c.148.294.491.604 1.131.604.688 0 1.125-.502 1.125-.998 0-.201-.074-.376-.27-.55-.215-.192-.577-.373-1.076-.473-.68-.136-1.432-.361-2.035-.8-.66-.48-1.12-1.207-1.119-2.174q0-.053.004-.105l.002-.004C8.695 7.994 10.358 6.875 12 6.875c1.66 0 2.778.962 3.234 2.05l.084.219.03.111a1.126 1.126 0 0 1-2.123.708l-.043-.107-.051-.125c-.148-.295-.491-.606-1.131-.606-.825 0-1.124.516-1.125.75l-.001.004.001.002c0 .107.022.161.04.193a.5.5 0 0 0 .153.16c.21.152.584.3 1.153.413l.278.063c1.402.36 2.876 1.351 2.876 3.165 0 1.854-1.562 3.25-3.375 3.25-1.658 0-2.778-.96-3.234-2.05l-.082-.22-.031-.11a1.124 1.124 0 0 1 .743-1.312"
      />
    </svg>
  );
}
